export default () => {
  const $body = $('.js-page');

  $(window).scroll(function () {
    let _top = $(this).scrollTop();

    if (0 < _top) {
      $body.addClass("is-scrolled");
    }else{
      $body.removeClass("is-scrolled");
    }
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/utilities/scrollPage.js